<template>
    <div>
        <buttonlist @help="help" @exps="exps" ref="SetBtn"></buttonlist>
        <el-tabs :tab-position="'top'" type="" v-model="activeName" @tab-click="selectInfo">
            <el-tab-pane :label="$t('getapi[12887]')" name="0">
                <table>
                    <tr>
                        <td>{{$t("getapi[7436]")}}</td>
                        <td><el-input v-model="countplansign" type="text" size="mini" class="mcolor"></el-input></td>
                        <td><el-button type="primary" size="mini" style="margin-left: 5px;" @click="getView()">{{ $t("getapi[938]") }}</el-button></td>
                    </tr>
                </table>
                <div id="xpane-0">
                    <vxe-table
                            :data="dataSet"
                            v-loading="loading"
                            border
                            stripe
                            resizable
                            size="mini"
                            :height="tableHeight"
                            :auto-resize="true"
                            ref="singleTable"
                    >
                        <vxe-table-column show-overflow field="count_plan_sign" :title="$t('getapi[7436]')"/>
                        <vxe-table-column show-overflow field="count_date" :title="$t('getapi[7439]')"/>
                        <vxe-table-column show-overflow field="count_area" :title="$t('getapi[7432]')"/>
                        <vxe-table-column show-overflow field="part_code" :title="$t('getapi[112]')"/>
                        <vxe-table-column show-overflow field="part_version" :title="$t('getapi[149]')"/>
                        <vxe-table-column show-overflow field="part_category" :title="$t('getapi[4241]')"/>
                        <vxe-table-column show-overflow field="sys_measure" :title="$t('getapi[7444]')"/>
                        <vxe-table-column show-overflow field="item_code" :title="$t('getapi[876]')"/>
                        <vxe-table-column show-overflow field="cargo_position" :title="$t('getapi[1957]')"/>
                        <vxe-table-column show-overflow field="qty" :title="$t('getapi[7443]')" align="right">
                            <template slot-scope="scope">
                                {{ scope.row.qty | thousandth2 }}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-overflow field="qty_on_hand" :title="$t('getapi[2240]')" align="right">
                            <template slot-scope="scope">
                                {{ scope.row.qty_on_hand | thousandth2 }}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-overflow field="diff_qty" :title="$t('getapi[12474]')" align="right">
                            <template slot-scope="scope">
                                {{ scope.row.diff_qty | thousandth2 }}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-overflow field="difference_rate" :title="$t('getapi[12898]')" align="right"/>
                        <vxe-table-column show-overflow field="difference_amount" :title="$t('getapi[12899]')" align="right"/>
                        <vxe-table-column show-overflow field="count_person" :title="$t('getapi[12874]')"/>
                        <vxe-table-column show-overflow field="review_person" :title="$t('getapi[12877]')"/>
                        <vxe-table-column show-overflow field="confirm_person" :title="$t('getapi[12880]')"/>
                    </vxe-table>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[12888]')" name="1">
                <table>
                    <tr>
                        <td>{{$t("getapi[7436]")}}</td>
                        <td><el-input v-model="countplansign1" type="text" size="mini" class="mcolor"></el-input></td>
                        <td><el-button type="primary" size="mini" style="margin-left: 5px;" @click="getView1()">{{ $t("getapi[938]") }}</el-button></td>
                    </tr>
                </table>
                <div id="xpane-1">
                    <vxe-table
                            :data="dataSet1"
                            v-loading="loading"
                            border
                            stripe
                            resizable
                            size="mini"
                            :height="tableHeight"
                            :auto-resize="true"
                            ref="singleTable1"
                    >
                        <vxe-table-column show-overflow field="count_plan_sign" :title="$t('getapi[7436]')"/>
                        <vxe-table-column show-overflow field="part_code" :title="$t('getapi[112]')"/>
                        <vxe-table-column show-overflow field="part_version" :title="$t('getapi[149]')"/>
                        <vxe-table-column show-overflow field="part_category" :title="$t('getapi[4241]')"/>
                        <vxe-table-column show-overflow field="sys_measure" :title="$t('getapi[7444]')"/>
                        <vxe-table-column show-overflow field="qty" :title="$t('getapi[7443]')" align="right">
                            <template slot-scope="scope">
                                {{ scope.row.qty | thousandth2 }}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-overflow field="qty_on_hand" :title="$t('getapi[2240]')" align="right">
                            <template slot-scope="scope">
                                {{ scope.row.qty_on_hand | thousandth2 }}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-overflow field="diff_qty" :title="$t('getapi[12474]')" align="right">
                            <template slot-scope="scope">
                                {{ scope.row.diff_qty | thousandth2 }}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-overflow field="difference_rate" :title="$t('getapi[12898]')" align="right"/>
                        <vxe-table-column show-overflow field="difference_amount" :title="$t('getapi[12899]')" align="right"/>
                    </vxe-table>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[12889]')" name="2">
                <table>
                    <tr>
                        <td>{{$t("getapi[7436]")}}</td>
                        <td><el-input v-model="countplansign2" type="text" size="mini" class="mcolor"></el-input></td>
                        <td><el-button type="primary" size="mini" style="margin-left: 5px;" @click="getView2()">{{ $t("getapi[938]") }}</el-button></td>
                    </tr>
                </table>
                <div id="xpane-2">
                    <vxe-table
                            :data="dataSet2"
                            v-loading="loading"
                            border
                            stripe
                            resizable
                            size="mini"
                            :height="tableHeight"
                            :auto-resize="true"
                            ref="singleTable2"
                    >
                        <vxe-table-column show-overflow field="Count_Plan_Sign" :title="$t('getapi[7436]')"/>
                        <vxe-table-column show-overflow field="Count_Card_No" :title="$t('getapi[7431]')"/>
                        <vxe-table-column show-overflow field="Count_Date" :title="$t('getapi[7439]')"/>
                        <vxe-table-column show-overflow field="Count_Card_Issue_No" :title="$t('getapi[7430]')"/>
                        <vxe-table-column show-overflow field="Count_Area" :title="$t('getapi[7432]')"/>
                        <vxe-table-column show-overflow field="Part_Code" :title="$t('getapi[112]')"/>
                        <vxe-table-column show-overflow field="Part_Version" :title="$t('getapi[149]')"/>
                        <vxe-table-column show-overflow field="so_code" :title="$t('getapi[4285]')"/>
                        <vxe-table-column show-overflow field="Routing_No" :title="$t('getapi[573]')"/>
                        <vxe-table-column show-overflow field="Part_Category" :title="$t('getapi[4241]')"/>
                        <vxe-table-column show-overflow field="Count_Measure" :title="$t('getapi[888]')"/>
                        <vxe-table-column show-overflow field="Sys_Measure" :title="$t('getapi[7444]')"/>
                        <vxe-table-column show-overflow field="item_code" :title="$t('getapi[876]')"/>
                        <vxe-table-column show-overflow field="cargo_position" :title="$t('getapi[1957]')"/>
                        <vxe-table-column show-overflow field="count_person" :title="$t('getapi[12874]')"/>
                        <vxe-table-column show-overflow field="review_person" :title="$t('getapi[12877]')"/>
                        <vxe-table-column show-overflow field="confirm_person" :title="$t('getapi[12880]')"/>
                        <vxe-table-column show-overflow field="qty" :title="$t('getapi[7443]')" align="right">
                            <template slot-scope="scope">
                                {{ scope.row.qty | thousandth2 }}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-overflow field="shop_qty" :title="$t('getapi[4852]')" align="right">
                            <template slot-scope="scope">
                                {{ scope.row.shop_qty | thousandth2 }}
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[12890]')" name="3">
                <table>
                    <tr>
                        <td>{{$t("getapi[7436]")}}</td>
                        <td><el-input v-model="countplansign3" type="text" size="mini" class="mcolor"></el-input></td>
                        <td><el-button type="primary" size="mini" style="margin-left: 5px;" @click="getView3()">{{ $t("getapi[938]") }}</el-button></td>
                    </tr>
                </table>
                <div id="xpane-3">
                    <vxe-table
                            :data="dataSet3"
                            v-loading="loading"
                            border
                            stripe
                            resizable
                            size="mini"
                            :height="tableHeight"
                            :auto-resize="true"
                            ref="singleTable3"
                    >
                        <vxe-table-column show-overflow field="count_status_name" :title="$t('getapi[552]')" width="100"/>
                        <vxe-table-column show-overflow field="rate" :title="$t('getapi[12894]')" align="right" width="100">
                            <template slot-scope="scope">
                                {{ $processdata.mathRound1($processdata.floatMul(scope.row.rate,100)) + '%' }}
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[12891]')" name="4">
                <table>
                    <tr>
                        <td>{{$t("getapi[7436]")}}</td>
                        <td><el-input v-model="countplansign4" type="text" size="mini" class="mcolor"></el-input></td>
                        <td><el-button type="primary" size="mini" style="margin-left: 5px;" @click="getView4()">{{ $t("getapi[938]") }}</el-button></td>
                    </tr>
                </table>
                <div id="xpane-4">
                    <vxe-table
                            :data="dataSet4"
                            v-loading="loading"
                            border
                            stripe
                            resizable
                            size="mini"
                            :height="tableHeight"
                            :auto-resize="true"
                            ref="singleTable4"
                    >
                        <vxe-table-column show-overflow field="Count_Area" :title="$t('getapi[7432]')" width="100"/>
                        <vxe-table-column show-overflow field="numerator" :title="$t('getapi[12892]')" width="100">
                            <template slot-scope="scope">
                                {{ scope.row.numerator | thousandth2 }}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-overflow field="denominator" :title="$t('getapi[12893]')" width="100">
                            <template slot-scope="scope">
                                {{ scope.row.denominator | thousandth2 }}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-overflow field="count_status" :title="$t('getapi[552]')" width="100"/>
                        <vxe-table-column show-overflow field="rate" :title="$t('getapi[12894]')" align="right" width="100">
                            <template slot-scope="scope">
                                {{ $processdata.mathRound1($processdata.floatMul(scope.row.rate,100)) + '%' }}
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import Common from "@/components/Common";
    import Array from "@/components/Array";

    export default {
        name: "3_partdiff",
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight1
            }
        },
        data() {
            return {
                userData: [], // 用户信息
                DbTbNames: "",
                pageIndex: 1, // 当前页
                pageSize: 1000000, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                scrollTop: 0,
                scrollTop1: 0,
                scrollTop2: 0,
                scrollTop3: 0,
                scrollTop4: 0,
                countplansign:'',//盘点计划
                dataSet:[],
                countplansign1:'',//盘点计划
                dataSet1:[],
                countplansign2:'',//盘点计划
                dataSet2:[],
                countplansign3:'',//盘点计划
                dataSet3:[],
                countplansign4:'',//盘点计划
                dataSet4:[],
                activeName:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this;
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0);
                    }, 500);
                });
            },
            'dataSet1': function () {
                let that = this;
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(1);
                    }, 500);
                });
            },
            'dataSet2': function () {
                let that = this;
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(2);
                    }, 500);
                });
            },
            'dataSet3': function () {
                let that = this;
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(3);
                    }, 500);
                });
            },
            'dataSet4': function () {
                let that = this;
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(4);
                    }, 500);
                });
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem("userData");
            that.authority();
        },
        activated() {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                }, false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                }, false)
                that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                }, false)
                that.$refs.singleTable3.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                }, false)
                that.$refs.singleTable4.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop4 = res.target.scrollTop
                }, false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop = this.scrollTop;
                    this.$refs.singleTable.bodyWrapper.scrollTop1 = this.scrollTop1;
                    this.$refs.singleTable.bodyWrapper.scrollTop2 = this.scrollTop2;
                    this.$refs.singleTable.bodyWrapper.scrollTop3 = this.scrollTop3;
                    this.$refs.singleTable.bodyWrapper.scrollTop4 = this.scrollTop4;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12886]"),this.$t("getapi[979]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                let limits = 1;
                that.$refs.SetBtn.SetButtonEnable("export", true);
                return;
            },
            getView() {
                let that = this;
                if (that.$limits.fnIsEmpty(that.countplansign)) {
                    that.$message.warning(that.$t("getapi[11932]"));
                    return;
                }
                let parm =
                {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    CountPlanSign: that.countplansign,
                    Param: [],
                    LangType:  that.$processdata.getLang()
                }
                that.loading = true;
                that.$http.urlpost("/Inv/Manager/InventoryCountPartCargoDiff", parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.totalcost = that.$processdata.explainCallbackMsg(res.Msg);
                    }
                    that.loading = false;
                });
            },
            getView1(){
                let that = this;
                if (that.$limits.fnIsEmpty(that.countplansign1)) {
                    that.$message.warning(that.$t("getapi[11932]"));
                    return;
                }
                let parm =
                    {
                        PageIndex: that.pageIndex,
                        PageSize: that.pageSize,
                        CountPlanSign: that.countplansign1,
                        Param: [],
                        LangType:  that.$processdata.getLang()
                    }
                that.loading = true;
                that.$http.urlpost("/Inv/Manager/InventoryCountPartDiff", parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet1 = res.DataContent;
                        that.totalcost = that.$processdata.explainCallbackMsg(res.Msg);
                    }
                    that.loading = false;
                });
            },
            getView2(){
                let that = this;
                if (that.$limits.fnIsEmpty(that.countplansign2)) {
                    that.$message.warning(that.$t("getapi[11932]"));
                    return;
                }
                let parm =
                    {
                        PageIndex: that.pageIndex,
                        PageSize: that.pageSize,
                        CountPlanSign: that.countplansign2,
                        Param: [],
                        LangType:  that.$processdata.getLang()
                    }
                that.loading = true;
                that.$http.urlpost("/Inv/Manager/ProductionCountDiff", parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet2 = res.DataContent;
                        that.totalcost = that.$processdata.explainCallbackMsg(res.Msg);
                    }
                    that.loading = false;
                });
            },
            getView3(){
                let that = this;
                if (that.$limits.fnIsEmpty(that.countplansign3)) {
                    that.$message.warning(that.$t("getapi[11932]"));
                    return;
                }
                let parm ={
                    CountPlanSign: that.countplansign3,
                }
                that.loading = true;
                that.$http.urlpost("/Inv/Manager/CountInventoryProgress1", parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet3 = res.dt1;
                        that.totalcost = that.$processdata.explainCallbackMsg(res.Msg);
                    }
                    that.loading = false;
                });
            },
            getView4(){
                let that = this;
                if (that.$limits.fnIsEmpty(that.countplansign4)) {
                    that.$message.warning(that.$t("getapi[11932]"));
                    return;
                }
                let parm = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    CountPlanSign: that.countplansign4,
                    Param: [],
                    LangType:  that.$processdata.getLang()
                }
                that.loading = true;
                that.$http.urlpost("/Inv/Manager/CountInventoryProgress", parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet4 = res.DataContent;
                        that.totalcost = that.$processdata.explainCallbackMsg(res.Msg);
                    }
                    that.loading = false;
                });
            },
            selectInfo(tab, event) {
                let that = this;
                that.activeName = tab.name;
                if(tab.name == 3){
                    that.$refs.SetBtn.SetButtonEnable("export", false);
                } else {
                    that.$refs.SetBtn.SetButtonEnable("export", true);
                }
            },
            exps(){
                let that = this
                let parm = {}
                if(that.activeName == 0){
                     parm = {
                        PageIndex: that.pageIndex,
                        PageSize: that.pageSize,
                        CountPlanSign: that.countplansign,
                        Param: [],
                        LangType:  that.$processdata.getLang()
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                    that.loading = true;
                    that.$http.urlpost("/Inv/Manager/InventoryCountPartCargoDiffToExcel", parm, function (res) {
                        if (res.Success == 1) {
                            let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                        that.loading = false;
                    });
                } else if(that.activeName == 1){
                    parm = {
                        PageIndex: that.pageIndex,
                        PageSize: that.pageSize,
                        CountPlanSign: that.countplansign1,
                        Param: [],
                        LangType:  that.$processdata.getLang()
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                    that.loading = true;
                    that.$http.urlpost("/Inv/Manager/InventoryCountPartDiffToExcel", parm, function (res) {
                        if (res.Success == 1) {
                            let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                        that.loading = false;
                    });
                } else if(that.activeName == 2){
                    parm = {
                        PageIndex: that.pageIndex,
                        PageSize: that.pageSize,
                        CountPlanSign: that.countplansign2,
                        Param: [],
                        LangType:  that.$processdata.getLang()
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                    that.loading = true;
                    that.$http.urlpost("/Inv/Manager/ProductionCountDiffToExcel", parm, function (res) {
                        if (res.Success == 1) {
                            let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                        that.loading = false;
                    });
                } else if(that.activeName == 4){
                    parm = {
                        PageIndex: that.pageIndex,
                        PageSize: that.pageSize,
                        CountPlanSign: that.countplansign4,
                        Param: [],
                        LangType:  that.$processdata.getLang()
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                    that.loading = true;
                    that.$http.urlpost("/Inv/Manager/CountInventoryProgressToExcel", parm, function (res) {
                        if (res.Success == 1) {
                            let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                        that.loading = false;
                    });
                }
            },
        },
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
